import { buildComponent } from '#components'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

const BlogPastEvents = buildComponent({
  name: 'blog-past-events',
  onConnected: (component) => {
    initSwiper(component.querySelector<HTMLElement>('.swiper'))
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'blog-past-events': typeof BlogPastEvents
  }
}

function initSwiper(swiperEl?: HTMLElement | null) {
  if (!swiperEl) return

  const slideCount = swiperEl.querySelectorAll<HTMLElement>('.swiper-slide').length

  new Swiper(swiperEl, {
    modules: [Navigation],
    slidesPerView: 1.3,
    spaceBetween: 20,
    speed: 500,
    breakpoints: {
      768: {
        slidesPerView: 2.5
      },
      990: {
        slidesPerView: slideCount > 4 ? 4.15 : 4,
        spaceBetween: 45
      }
    },
    navigation: {
      nextEl: swiperEl.querySelector<HTMLElement>('.swiper-button-next'),
      prevEl: swiperEl.querySelector<HTMLElement>('.swiper-button-prev')
    }
  })
}
